'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import TechnologyFaq from '@/components/technologies/technology-faq';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MobileappFAQ from '@/components/faqs/mobileapp-faq';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import MobileappServices from '@/components/technologies/mobileapp-services';
import MobileServies from '@/components/technologies/mobileapp-demand';

import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Maximize your business potential with our custom mobile app development services. We create native and cross-platform mobile apps for modern platforms to help you achieve your business goals rapidly."
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'mobileapp-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                Mobile App <div>Development Company</div>
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Mobile App" />
            <MobileappServices title="Redefine Your Business Operations with Our Customized Mobile App Development Services"></MobileappServices>
            <MobileServies />
            <HireProcess
                bg="bg-mobileapp"
                pageTitle="Hire Mobile App Developers To Accelerate Your Business Growth"
                desc="Your business deserves the best. Partner with our skilled mobile app developers to build high-performing and tailor-made mobile apps for unmatched business growth. "
            />
            <WhyChooseUs pageTitle="Why is Moweb recognized as a top mobile app development company?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Mobile App Developers"
                desc="Select from different engagement models to hire Mobile App Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <TechnologyFaq title="FAQs On Mobile App Development Services" bg="bg-mobileapp">
                <MobileappFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
